export default __webpack_public_path__ + "8137872e1ff6a2cf12b6484594883fce.jpg";